import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa";

const NuestrosServicios = () => {

  const services = [
    { name: "Registro de Obras" },
    { name: "Obras Literarias" },
    { name: "Obras por Encargo" },
    { name: "Obras Artísticas" },
    { name: "Obras Musicales" },
    { name: "Cesiones de Derecho" },
  ];

  return (
    <div className="pt-12">
      <motion.h2
        className="text-[#028299] text-5xl text-center font-semibold mb-8"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Nuestros servicios
      </motion.h2>
      <motion.h3
        className="text-slate-700 text-2xl text-center font-light mb-8"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Protegemos tus obras, protegemos tu talento
      </motion.h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-12">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="overflow-hidden flex flex-row items-center justify-start gap-2"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            <FaCheck className="bg-teal-300/50 text-teal-600 p-2 w-10 h-10 rounded-full"/>
              <h3 className="text-slate-700 font-semibold text-lg text-center ">
                {service.name}
              </h3>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NuestrosServicios;
